import { createStrictContext as i } from "../../util/context/createStrictContext.js";
import { useState as o } from "react";
import { jsx as l } from "react/jsx-runtime";
const [u, C] = i("LogicControl"), f = (r) => {
  const {
    children: t
  } = r, [e, n] = o(!1), [c, s] = o(null);
  return /* @__PURE__ */ l(u, {
    value: {
      forceLogout: e,
      generalError: c,
      setForceLogout: n,
      setGeneralError: s
    },
    children: t
  });
};
export {
  f as LogicControlProvider,
  C as useLogicControlContext
};
//# sourceMappingURL=LogicControlContext.js.map
